import { reduxKey } from './constants';

export enum RequestStatus {
  Processing,
  Success,
  Failure,
}

export interface TagInputStoreSlice {
  tagSearchResults: string[];
  searchRequestStatus?: RequestStatus;
}

export interface TagInputStoreState {
  [reduxKey]: TagInputStoreSlice;
}
